/** An element 'long click' event that assists in unifying Mouse and Touch Events
    over Mobile and Desktop Platforms
*/
export default class LongClick extends CustomEvent {
    constructor(caller) {
        super('longclick', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
